import { render, staticRenderFns } from "./InstrumentItemInfo.vue?vue&type=template&id=1bcf1d5d&"
import script from "./InstrumentItemInfo.vue?vue&type=script&lang=js&"
export * from "./InstrumentItemInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports